import React, { useState, useEffect } from 'react';
import { Table, Badge, Select, Spin, Pagination } from 'antd';
import moment from 'moment';
import useAppLoginStore from './store';
import { useParams } from 'react-router-dom';

const { Option } = Select;

const MoengageEventDetails = () => {
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [selectedEventName, setSelectedEventName] = useState('app_logout');
    const [currentPage, setCurrentPage] = useState(1);
    const pageSize = 10; // Define the page size

    const { fetchMoengageDetails, moengageEvents, totalMoeItems } = useAppLoginStore();
    const { id } = useParams();

    const columns = [
        {
            title: 'Event Name',
            dataIndex: 'eventName',
            key: 'eventName',
            width: 150,
        },
        {
            title: 'Non-Interactive',
            dataIndex: 'isNonInteractive',
            key: 'isNonInteractive',
            render: (isNonInteractive) => (
                <Badge color={isNonInteractive ? 'green' : 'red'}>
                    {isNonInteractive ? 'Yes' : 'No'}
                </Badge>
            ),
            width: 150,
        },
        {
            title: 'Case ID',
            dataIndex: ['generalAttributes', 'case_id'],
            key: 'case_id',
            width: 200,
        },
        {
            title: 'User Type',
            dataIndex: ['generalAttributes', 'user_type'],
            key: 'user_type',
            width: 150,
        },
        {
            title: 'Gender',
            dataIndex: ['generalAttributes', 'gender'],
            key: 'gender',
            width: 100,
        },
        {
            title: 'Order Count',
            dataIndex: ['generalAttributes', 'order_count'],
            key: 'order_count',
            width: 150,
        },
        {
            title: 'Last Order Date',
            dataIndex: ['generalAttributes', 'last_order_date'],
            key: 'last_order_date',
            render: (date) => moment(date).format('YYYY-MM-DD HH:mm:ss'),
            width: 200,
        },
        {
            title: 'Location',
            dataIndex: ['generalAttributes', 'Location'],
            key: 'Location',
            width: 150,
        },
        {
            title: 'Created At',
            dataIndex: 'createdAt',
            key: 'createdAt',
            render: (date) => moment(date).format('YYYY-MM-DD HH:mm:ss'),
            width: 200,
        },
    ];

    useEffect(() => {
        setLoading(true);
        fetchMoengageDetails(id, currentPage,)
            .then(() => setLoading(false));
    }, [id, currentPage]);

    useEffect(() => {
        setData(moengageEvents);
    }, [moengageEvents]);

    const handlePageChange = (page) => {
        setCurrentPage(page);
    };

    return (
        <div>
            <Spin spinning={loading}>
                <Table
                    columns={columns}
                    dataSource={data}
                    rowKey={(record) => record.generalAttributes.case_id}
                    pagination={false}
                    scroll={{ x: 1500, y: 600 }}
                />
                <Pagination
                    current={currentPage}
                    pageSize={pageSize}
                    total={totalMoeItems}
                    onChange={handlePageChange}
                    showSizeChanger={false}
                    className='d-flex justify-content-center align-items-center mt-3'
                />
            </Spin>
        </div>
    );
};

export default MoengageEventDetails;
